import { callFunction } from "./functions-client";

// Admin account + role management (admin-only endpoints).

export interface AdminAccount {
  id: string;
  email: string | null;
  status: string;
  identity_verified: boolean;
  created_at: string;
  roles: string[];
}

export const listAccounts = () =>
  callFunction<{ accounts: AdminAccount[] }>("identity/admin-accounts", { method: "GET" });

export const setRole = (account_id: string, role: string, op: "grant" | "revoke") =>
  callFunction<{ ok: boolean }>("identity/admin-set-role", { body: { account_id, role, op } });

export const setAccountStatus = (account_id: string, status: "active" | "suspended") =>
  callFunction<{ ok: boolean }>("identity/admin-set-status", { body: { account_id, status } });

export interface AuditEntry {
  id: string;
  actor: string | null;
  actor_email: string | null;
  action: string;
  target: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
}

export const listAudit = (action?: string) =>
  callFunction<{ entries: AuditEntry[]; actions: string[] }>(
    `identity/admin-audit${action ? `?action=${encodeURIComponent(action)}` : ""}`,
    { method: "GET" },
  );

// Enterprise Admin control plane (LOS Phase 17).
export interface PlatformMetrics {
  accounts: number;
  verified_accounts: number;
  open_jobs: number;
  open_loads: number;
  open_disputes: number;
  open_reports: number;
  open_tickets: number;
  new_accounts_7d: number;
}

export interface FeatureFlag {
  key: string;
  description: string | null;
  enabled: boolean;
  updated_at: string;
}

export const adminMetrics = () =>
  callFunction<{ metrics: PlatformMetrics }>("admin/metrics", { method: "GET" });

export const listFlags = () =>
  callFunction<{ flags: FeatureFlag[] }>("admin/flags", { method: "GET" });

export const setFlag = (key: string, enabled: boolean, description?: string) =>
  callFunction<{ flag: FeatureFlag }>("admin/flag-set", { body: { key, enabled, description } });
